import * as MobileSelectedFareStyles from './MobileSelectedFare.css';
export default {
    MobileSelectedFareStyles
};
